import React from "react";
import EwaybillResultTable from "./EwaybillResultTable";
import EwaybillResultAlert from "./EwaybillResultAlert";
import MultiPlatformEwaybillResultStore from "./MultiPlatformEwaybillResultStore";
import { observer } from "mobx-react-lite";

export interface EwaybillResultProps {
    store: MultiPlatformEwaybillResultStore;

    printerName: string;
}

const EwaybillResult: React.FC<EwaybillResultProps> = (props) => {
    const { store, printerName } = props;

    if (!store) {
        return null;
    }

    return (
        <>
            <EwaybillResultAlert printerName={printerName} store={store} />

            <EwaybillResultTable printerName={printerName} store={store} />
        </>
    );
};

export default observer(EwaybillResult);
